import Multiselect from "multiselect-react-dropdown";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { withTranslation ,useTranslation} from "react-i18next";
import { BiCaretUp, BiX } from "react-icons/bi";
import { toast } from "react-toastify";
import { RegulationContext } from "../../../App";
import ReportingPeriod from "../../../components/Regulation/ReportingPeriod";
import { CategoryList, CompareCategoryType, DataViewCategoryType, LS_AUTHORITY_KEY, LS_DV_FILTER_KEY, MonthsExt, StandardCategory, startYear } from "../../../core/constants/common";
import CompanyService from "../../../core/service/CompanyService";
import FormService from "../../../core/service/FormService";
import KPIService from "../../../core/service/KPIService";
import StandardService from "../../../core/service/StandardService";
import Utils from "../../../core/utilities/Utils";
import './DataView.scss';
import UserService from "../../../core/service/UserService";
import QuestionService from "../../../core/service/QuestionService";

const DataViewFilter = ({ t, view, onApplyFilter, yearFilter, dataViewType, onResetFilter, viewFilter, forGraph = false, onLoad, onFilterHide, goalId }) => {

	const [viewType, setViewType] = useState(view ?? 'DATA_VIEW');
	const dvFilter = viewType == 'COMPARE' ? [] : JSON.parse(localStorage.getItem(LS_DV_FILTER_KEY));
	const { glbRegulation } = useContext(RegulationContext);
	const glbRegulationId = glbRegulation?.id ?? "";
	const month = Utils.getMonthFromFrequency(glbRegulation.frequency);
	const year = new Date().getFullYear();
	const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const companyId = lsData.profile.company.id;

	const [filter, setFilter] = useState({
		reportingPeriod: yearFilter ? `${yearFilter}-01-01` : dvFilter?.reportingPeriod ?? `${year}-${month}-01`,
		categoryType: dvFilter?.categoryType ?? DataViewCategoryType.ENVIRONMENTAL,
		topicIds: dvFilter?.topicIds ?? [],
		metricIds: dvFilter?.metricIds ?? [],
		businessUnitIds: dvFilter?.businessUnitIds ?? [],
		parentEntities: dvFilter?.parentEntities ?? [],
		childEntities: dvFilter?.childEntities ?? [],
		periodFrom: yearFilter ? `${yearFilter}-01-01` : `${year}-01-01`,
		periodTo: yearFilter ? `${yearFilter}-12-31` : `${year}-12-31`,
		groupIds: dvFilter?.groupIds ?? [],
		periodType: 'YEARLY',
		period: null,
		kpiCategory: '',
		goalId: goalId ?? '',
		kpiId: '',
		entityId: '',
		assigneeId: ''
	});
	const [topics, setTopics] = useState([]);
	const [parentEntities, setParentEntities] = useState([]);
	const [childEntities, setChildEntities] = useState([]);
	const [reportingFrequency, setReportingFrequency] = useState('ANNUAL');
	const [groups, setGroups] = useState([]);
	const [period, setPeriod] = useState([]);
	const [displayFilter, setDisplayFilter] = useState(true);
	const optionsMonth = MonthsExt({ t });
	const currentYear = new Date().getFullYear();
	const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
	const [selectedData, setSelectedData] = useState([]);
	const [goals, setGoals] = useState([]);
	const [entities, setEntities] = useState([]);
	const [kpis, setKPIs] = useState([]);
	const [kpiCategories, setKPICategories] = useState([]);
	const [users, setUsers] = useState([]);
	const { k, i18n } = useTranslation();
	const topicsRef = useRef();
	const patentEntRef = useRef();
	const childEntRef = useRef();
	const enterpriseRef = useRef();

	useEffect(() => {
		if (!glbRegulationId) return;

		if (dataViewType === 'KPI') {
			fetchKPICategories();
			fetchGoals('', true);
			if (forGraph) return;

			fetchEntities();
		} else {
			getTopics();
			getEnterprisesByLevel(1);
			getEnterprisesByLevel(2);
			getGroups();
		}
	}, [glbRegulationId, filter.categoryType, dataViewType]);

	useEffect(() => {
		setPeriodItems(filter.periodType);
	}, [filter.periodType]);

	useEffect(() => {
		setViewType(view);
		if (view === 'DATA_VIEW') {
			setFilter({ ...filter, periodFrom: null, periodTo: null });
		} else {
			setFilter({
				...filter,
				periodFrom: yearFilter ? `${yearFilter}-01-01` : `${year}-01-01`,
				periodTo: yearFilter ? `${yearFilter}-12-31` : `${year}-12-31`,
			});
		}
		if (view === 'ACTIONS_VIEW' && !forGraph) {
			fetchUsers();
		}
		setReportingFrequency('ANNUAL');
	}, [view]);

	useEffect(() => {
		setDisplayFilter(viewFilter);
	}, [viewFilter]);

	useEffect(() => {
		if (!filter.kpiCategory) return;

		setGoals([]);
		setKPIs([]);
		setFilter({
			...filter,
			goalId: '',
			kpiId: ''
		});
		fetchGoals(filter.kpiCategory);
	}, [filter.kpiCategory]);

	useEffect(() => {
		if (!filter.goalId) return;

		setFilter({
			...filter,
			kpiId: ''
		});
		fetchKPIs(filter.goalId);
	}, [filter.goalId]);

	const setPeriodItems = (value) => {
		const yearOptions = [];
		if (value === 'YEARLY') {
			let count = 0;
			for (let i = currentYear; i >= startYear; i--) {
				yearOptions.push({
					id: count,
					value: i,
					displayValue: i,
					category: 'Years'
				});
				count++
			}
			setPeriod(yearOptions);
			setSelectedData([])
		} else if (value === 'QUARTERLY') {
			let count = 0;
			for (let i = currentYear; i >= startYear; i--) {
				for (let j = 0; j < quarters.length; j++) {
					yearOptions.push({
						category: i,
						value: quarters[j],
						displayValue: i + ' - ' + quarters[j],
						id: count,
					});
					count++
				}
			}
			// yearOptions.sort((a, b) => b.category - a.category);
			setPeriod(yearOptions);
			setSelectedData([])
		} else if (value === 'MONTHLY') {
			let count = 0;
			for (let i = currentYear; i >= startYear; i--) {
				for (let j = 0; j < optionsMonth.length; j++) {
					yearOptions.push({
						category: i,
						value: optionsMonth[j].value,
						displayValue: i + ' - ' + optionsMonth[j].label,
						id: count,
					});
					count++
				}
			}
			// yearOptions.sort((a, b) => b.category - a.category);
			setPeriod(yearOptions);
			setSelectedData([])
		} else {
			setPeriod([]);
			setSelectedData([])
		}
	}

	const onSelectDeSelectPeriod = (selectedItem) => {
		let existData = [...selectedData];
		const index = existData.indexOf(selectedItem);
		if (index >= 0) {
			existData.splice(index, 1);
		} else {
			existData.push(selectedItem);
		}
		setSelectedData(existData);
		preparePeriod(existData);
	};

	const preparePeriod = (data) => {
		if (filter.periodType == 'YEARLY') {
			const objectTags = Object.fromEntries(data.map((t) => [t.value, []]))
			setFilter({
				...filter,
				period: objectTags,
			});
		} else if (filter.periodType == 'QUARTERLY') {
			const result = Object.groupBy(data, ({ category }) => category);
			for (const year in result) {
				let values = data.filter(element => element['category'] == year);
				result[year] = [];
				values.forEach(data => {
					result[year].push(data['value']);
				})
			}
			setFilter({
				...filter,
				period: result,
			});
		} else {
			const result = Object.groupBy(data, ({ category }) => category);
			for (const year in result) {
				let values = data.filter(element => element['category'] == year);
				result[year] = [];
				values.forEach(data => {
					result[year].push(data['value']);
				})
			}
			setFilter({
				...filter,
				period: result,
			});
		}
	}

	const getSelectedPeriods = () => {
		return selectedData;
	}

	const getTopics = () => {
		StandardService.getTopicsByStandard(glbRegulationId, false, StandardCategory.QUANTITATIVE, filter.categoryType)
			.then(res => {
				if (res.status !== 200) return;

				setTopics(res.data);
			}).catch(err => { });
	};

	const getEnterprisesByLevel = (level) => {
		CompanyService.getEnterprisesByLevel(level).then(res => {
			if (res.status !== 200) return;

			const entities = res.data.sort((a, b) => a.sortOrder - b.sortOrder);
			if (level === 1) {
				setParentEntities(entities);
			} else if (level === 2) {
				setChildEntities(entities);
			}
		}).catch(err => { });
	};

	const getGroups = () => {
		FormService.listGroups().then(res => {
			if (res.status !== 200) return;

			setGroups(res.data);
		}).catch(err => { });
	};

	const onSelectDeSelectTopic = (selectedItem) => {
		const topicIds = [...filter.topicIds];
		const index = filter.topicIds.indexOf(selectedItem.id);
		if (index >= 0) {
			topicIds.splice(index, 1);
		} else {
			topicIds.push(selectedItem.id);
		}
		setFilter({
			...filter,
			topicIds: topicIds,
			metricIds: [],
		});
	};

	const getSelectedTopics = () => {
		const data = [];
		topics?.forEach(topic => {
			if (filter.topicIds.indexOf(topic.id) < 0) return;

			data.push(topic);
		});
		return data;
	};

	const onSelectDeSelectParentEntity = (item) => {
		const entities = [...filter.parentEntities];
		const index = filter.parentEntities.indexOf(item.id);
		if (index >= 0) {
			entities.splice(index, 1);
		} else {
			entities.push(item.id);
		}
		setFilter({
			...filter,
			parentEntities: entities
		});
	};

	const onSelectDeSelectChildEntity = (item) => {
		const entities = [...filter.childEntities];
		const index = filter.childEntities.indexOf(item.id);
		if (index >= 0) {
			entities.splice(index, 1);
		} else {
			entities.push(item.id);
		}
		setFilter({
			...filter,
			childEntities: entities
		});
	};

	const onSelectDeSelectGroup = (item) => {
		const groupIds = [...filter.groupIds];
		const index = filter.groupIds.indexOf(item.id);
		if (index >= 0) {
			groupIds.splice(index, 1);
		} else {
			groupIds.push(item.id);
		}
		setFilter({
			...filter,
			groupIds: groupIds
		});
	};

	const getSelectedParentEntities = () => {
		const data = [];
		parentEntities?.forEach(p => {
			if (filter.parentEntities.indexOf(p.id) < 0) return;

			data.push(p);
		});
		return data;
	};

	const getSelectedChildEntities = () => {
		const data = [];
		childEntities?.forEach(c => {
			if (filter.childEntities.indexOf(c.id) < 0) return;

			data.push(c);
		});
		return data;
	};

	const getSelectedGroups = () => {
		const data = [];
		groups?.forEach(g => {
			if (filter.groupIds.indexOf(g.id) < 0) return;

			data.push(g);
		});
		return data;
	};

	const applyFilter = () => {
		const filterData = JSON.parse(JSON.stringify(filter));
		filterData.businessUnitIds = [];
		filterData.parentEntities?.forEach(e => {
			filterData.businessUnitIds.push(e)
		});
		filterData.childEntities?.forEach(e => {
			filterData.businessUnitIds.push(e)
		});
		if (viewType === 'COMPARE') {
			const compareFilter = {
				standardId: glbRegulationId,
				periodType: filterData.periodType,
				period: filterData.period,
				category: filterData.categoryType ? CompareCategoryType[filterData.categoryType] : 'ENVIRONMENTAL',
				topicIds: filterData.topicIds,
				parentBranchIds: filterData.parentEntities,
				childBranchIds: filterData.childEntities,
				businessUnitIds: filterData.businessUnitIds,
			}
			if ((compareFilter.parentBranchIds.length > 0 || compareFilter.childBranchIds.length > 0) && compareFilter.topicIds.length > 0 && compareFilter.period != null) {
				onApplyFilter(compareFilter);
				onFilterHide(false);
			} else {
				toast.warning('Select any parent or child entity along with period and topic', {
					position: toast.POSITION.TOP_RIGHT,
					autoClose: 2000
				});
			}
		} else {
			setFilter(filterData);
			onApplyFilter(filterData);
			onFilterHide(false);
			localStorage.setItem(LS_DV_FILTER_KEY, JSON.stringify(filterData));
		}
	};
	const resetFilter = () => {
		setFilter({
			reportingPeriod: yearFilter ? `${yearFilter}-01-01` : `${new Date().getFullYear()}-01-01`,
			categoryType: DataViewCategoryType.ENVIRONMENTAL,
			topicIds: [],
			metricIds: [],
			businessUnitIds: [],
			parentEntities: [],
			childEntities: [],
			periodFrom: yearFilter ? `${yearFilter}-01-01` : `${new Date().getFullYear()}-01-01`,
			periodTo: yearFilter ? `${yearFilter}-12-31` : `${new Date().getFullYear()}-12-31`,
			groupIds: [],
			periodType: 'YEARLY',
			period: null,
			kpiCategory: '',
			goalId: '',
			kpiId: '',
			entityId: '',
			assigneeId: ''
		});
		if (viewType === 'COMPARE') {
			setSelectedData([])
			onResetFilter();
			resetValues();
		} else {
			setSelectedData([])
			localStorage.removeItem(LS_DV_FILTER_KEY);
			resetValues();
			const filterToSend = {
				reportingPeriod: yearFilter ? `${yearFilter}-01-01` : `${new Date().getFullYear()}-01-01`,
				categoryType: DataViewCategoryType.ENVIRONMENTAL,
				topicIds: [],
				metricIds: [],
				businessUnitIds: [],
				parentEntities: [],
				childEntities: [],
				periodFrom: yearFilter ? `${yearFilter}-01-01` : `${new Date().getFullYear()}-01-01`,
				periodTo: yearFilter ? `${yearFilter}-12-31` : `${new Date().getFullYear()}-12-31`,
				groupIds: [],
				periodType: 'YEARLY',
				period: null
			}
			onApplyFilter(filterToSend);
		}
	};

	const resetValues = () => {
		topicsRef?.current?.resetSelectedValues();
		patentEntRef?.current?.resetSelectedValues();
		childEntRef?.current?.resetSelectedValues();
		enterpriseRef?.current?.resetSelectedValues();
	}

	const renderReportingPeriodFilter = () => {
		if (dataViewType === 'KPI') return <></>;

		if (viewType === 'DATA_VIEW') {
			return (
				<>
					<div className="col-lg-12 p-2">
						<label>{t("ReportingPeriod.label")}</label>
						<ReportingPeriod
							defaultPeriod={filter.reportingPeriod}
							valueChangeCallback={(period) =>
								setFilter({ ...filter, reportingPeriod: `${period.year}-${period.month}-01` })
							} />
					</div>
				</>
			);
		} else if (viewType === 'COMPARE') {
			return (
				<>
					<div className="p-1">
						<Form.Check inline label={t("Yearly.label")}
							type="radio" id="freqYearRadioC" value={'YEARLY'}
							checked={filter.periodType === 'YEARLY' ? "checked" : ""}
							onChange={(e) => {
								setFilter({ ...filter, periodType: e.target.value, period: {} });
								setPeriodItems(e.target.value);
							}} />
						<Form.Check inline label={t("Quarterly.label")}
							type="radio" id="freqQuarterRadioC" value={'QUARTERLY'}
							checked={filter.periodType === 'QUARTERLY' ? "checked" : ""}
							onChange={(e) => {
								setFilter({ ...filter, periodType: e.target.value, period: {} });
								setPeriodItems(e.target.value);
							}} />
						<Form.Check inline label={t("Monthly.label")}
							type="radio" id="freqMonthRadioC" value={'MONTHLY'}
							checked={filter.periodType === 'MONTHLY' ? "checked" : ""}
							onChange={(e) => {
								setFilter({ ...filter, periodType: e.target.value, period: {} });
								setPeriodItems(e.target.value);
							}} />
					</div>
					{/* <div className="col-lg-12 p-2">
						<label htmlFor="granularityFilter">{t("Granularity.label")}</label>
						<select id="granularityFilter" className="form-select"
							value={filter.periodType}
							onChange={(e) => {
								setFilter({ ...filter, periodType: e.target.value, period: {} });
								setPeriodItems(e.target.value);
							}
							}>
							<option value='' key=''>{t("Select.label")}</option>
							<option value={'YEARLY'} key={'YEARLY'}>{t("Yearly.label")}</option>
							<option value={'QUARTERLY'} key={'QUARTERLY'}>{t("Quarterly.label")}</option>
							<option value={'MONTHLY'} key={'MONTHLY'}>{t("Monthly.label")}</option>
						</select>
					</div> */}
					<div className="col-lg-12 p-2">
						<label htmlFor="yearFilter">{t("ReportingPeriod.label")}</label>
						<Multiselect
							id="periodMultiSelect"
							key="id"
							options={period}
							placeholder={selectedData.length === 0 ? "Select " : ""}
							displayValue="displayValue"
							groupBy="category" showCheckbox
							style={{ chips: { maxWidth: '200px', whiteSpace: 'normal' } }}
							selectedValues={getSelectedPeriods()}
							selectionLimit="3"
							onSelect={(selectedList, selectedItem) => {
								onSelectDeSelectPeriod(selectedItem);
							}}
							onRemove={(selectedList, selectedItem) => {
								onSelectDeSelectPeriod(selectedItem);
							}}
						/>
					</div>
				</>
			);
		}
		if (viewType != 'COMPARE') {
			return (
				<>
					{/* className={`p-2 ${reportingFrequency === 'MONTHLY' ? 'col-lg-12' : 'col-lg-12'}`} */}
					<div className='col-lg-12 p-2'>
						<div className="mb-2">
							<Form.Check inline label={t("Yearly.label")}
								type="radio" id="freqYearRadio" value={'ANNUAL'}
								checked={reportingFrequency === 'ANNUAL' ? "checked" : ""}
								onChange={(e) => onReportingFrequencyChange('ANNUAL')} />
							<Form.Check inline label={t("Quarterly.label")}
								type="radio" id="freqQuarterRadio" value={'QUARTERLY'}
								checked={reportingFrequency === 'QUARTERLY' ? "checked" : ""}
								onChange={(e) => onReportingFrequencyChange('QUARTERLY')} />
							<Form.Check inline label={t("Monthly.label")}
								type="radio" id="freqMonthRadio" value={'MONTHLY'}
								checked={reportingFrequency === 'MONTHLY' ? "checked" : ""}
								onChange={(e) => onReportingFrequencyChange('MONTHLY')} />
						</div>
						<div className="row">
							{/* className={`p-2 ${reportingFrequency === 'MONTHLY' ? 'col-lg-12' : 'col-lg-12'}`} */}
							<div className='col-lg-12 p-2'>
								<ReportingPeriod
									defaultFrequency={reportingFrequency}
									defaultPeriod={viewType === 'CONSOLIDATED_VIEW' ? filter.periodFrom : filter.reportingPeriod}
									valueChangeCallback={(period) => setPeriodFilterForConsolidatedView({ from: period })} />
							</div>
							{
								reportingFrequency === 'MONTHLY' &&
								<div className="col-md-12 py-2 ">
									<ReportingPeriod
										defaultFrequency={reportingFrequency}
										defaultPeriod={viewType === 'CONSOLIDATED_VIEW' ? filter.periodTo : filter.reportingPeriod}
										valueChangeCallback={(period) => setPeriodFilterForConsolidatedView({ to: period })} />
								</div>
							}
						</div>
					</div>
				</>

			);
		}
	};

	const setPeriodFilterForConsolidatedView = ({ from, to }) => {
		let pFrom = null;
		let pTo = null;
		if (reportingFrequency === 'QUARTERLY') {
			let qMonthStart, qMonthEnd;
			if (from.month === '01') {
				qMonthStart = `01`; qMonthEnd = `03`;
			} else if (from.month === '04') {
				qMonthStart = '04'; qMonthEnd = `06`;
			} else if (from.month === '07') {
				qMonthStart = '07'; qMonthEnd = `09`;
			} else {
				qMonthStart = '10'; qMonthEnd = `12`;
			}
			pFrom = `${from.year}-${qMonthStart}-01`;
			let endingDay = Utils.getLastDayFor(`${from.year}-${qMonthEnd}-01`);
			pTo = `${from.year}-${qMonthEnd}-${endingDay}`;
		} else if (reportingFrequency === 'ANNUAL') {
			// Other frequencies, the from will have to be set
			pFrom = `${from.year}-01-01`;
			pTo = `${from.year}-12-31`;
		} else {
			// Monthly will have separate from and to
			if (from) {
				pFrom = `${from.year}-${from.month}-01`;
			} else {
				pFrom = filter.periodFrom;
			}
			if (to) {
				let endingDay = Utils.getLastDayFor(`${to.year}-${to.month}-01`);
				pTo = `${to.year}-${to.month}-${endingDay}`;
			} else {
				pTo = filter.periodTo;
			}
		}
		setFilter({
			...filter,
			periodFrom: pFrom,
			periodTo: pTo
		});
	};

	const onReportingFrequencyChange = (freq) => {
		setReportingFrequency(freq);
		const dateParts = filter.periodFrom.split('-');
		const yearPart = dateParts[0] ?? year;
		let pFrom = `${yearPart}-01-01`;;
		let pTo = `${yearPart}-12-31`;;
		switch (freq) {
			case 'QUARTERLY': {
				pFrom = `${yearPart}-01-01`;
				let endingDay = Utils.getLastDayFor(`${yearPart}-03-01`);
				pTo = `${yearPart}-03-${endingDay}`;
				break;
			}
			case 'MONTHLY': {
				pFrom = `${yearPart}-01-01`;
				pTo = `${yearPart}-01-31`;
				break;
			}
			default:
				break;
		}
		setFilter({
			...filter,
			periodFrom: pFrom,
			periodTo: pTo
		});
	};

	const renderMetricRelatedFilters = () => {
		return (
			<>
				<div className="col-lg-4 p-2">
					<label htmlFor="esgFilter">{t("Category.label")}</label>
					<select id="esgFilter"
						className="form-select"
						onChange={(e) => setFilter({ ...filter, categoryType: +e.target.value, topicIds: [], metricIds: [] })}
						required
						value={filter.categoryType}>
						{
							CategoryList({ t }).map(c => {
								return <option value={c.id} key={c.key}>{c.text}</option>
							})
						}
					</select>
				</div>
				<div className="col-lg-4 p-2">
					<label>{t("Topic.label")}</label>
					<Multiselect
						id="topicMultiSelect"
						key="topicMultiSelect"
						ref={topicsRef}
						options={topics}
						selectedValues={getSelectedTopics()}
						selectionLimit={viewType == 'COMPARE' ? 5 : null}
						onSelect={(selectedList, selectedItem) => {
							onSelectDeSelectTopic(selectedItem);
						}}
						onRemove={(selectedList, selectedItem) => {
							onSelectDeSelectTopic(selectedItem);
						}}
						placeholder={getSelectedTopics().length === 0 ? "Select " : ""}
						displayValue="name"
						style={{ chips: { maxWidth: '200px', whiteSpace: 'normal' } }}
					/>
				</div>
				<div className="col-lg-4 p-2">
					<label>{t("ParentEntity.label")}</label>
					<Multiselect
						id={`parentEntityMultiselect`}
						key={`parentEntityMultiselect`}
						options={parentEntities}
						ref={patentEntRef}
						selectedValues={getSelectedParentEntities()}
						selectionLimit={viewType == 'COMPARE' ? 5 : null}
						onSelect={(selectedList, selectedItem) => {
							onSelectDeSelectParentEntity(selectedItem);
						}}
						onRemove={(selectedList, selectedItem) => {
							onSelectDeSelectParentEntity(selectedItem);
						}}
						placeholder={getSelectedParentEntities().length === 0 ? "Select" : ""}
						displayValue="name"
						style={{ chips: { maxWidth: '200px', whiteSpace: 'normal' } }}
					/>
				</div>
				<div className="col-lg-4 p-2">
					<label>{t("ChildEntity.label")}</label>
					<Multiselect
						id={`childEntityMultiselect`}
						key={`childEntityMultiselect`}
						options={childEntities}
						ref={childEntRef}
						selectedValues={getSelectedChildEntities()}
						selectionLimit={viewType == 'COMPARE' ? 5 : null}
						onSelect={(selectedList, selectedItem) => {
							onSelectDeSelectChildEntity(selectedItem);
						}}
						onRemove={(selectedList, selectedItem) => {
							onSelectDeSelectChildEntity(selectedItem);
						}}
						placeholder={getSelectedChildEntities().length === 0 ? "Select " : ""}
						displayValue="name"
						style={{ chips: { maxWidth: '200px', whiteSpace: 'normal' } }}
					/>
				</div>
				{viewType == 'COMPARE' && (
					<div className="col-lg-12 p-2"></div>
				)}
				{
					(viewType != 'COMPARE') && (
						<div className="col-lg-4 p-2">
							<label>{t("EnterpriseGroup.label")}</label>
							<Multiselect
								id={`egMultiselect`}
								key={`egMultiselect`}
								options={groups}
								ref={enterpriseRef}
								selectedValues={getSelectedGroups()}
								onSelect={(selectedList, selectedItem) => {
									onSelectDeSelectGroup(selectedItem);
								}}
								onRemove={(selectedList, selectedItem) => {
									onSelectDeSelectGroup(selectedItem);
								}}
								placeholder={getSelectedGroups().length === 0 ? "Select " : ""}
								displayValue="groupName"
								style={{ chips: { maxWidth: '200px', whiteSpace: 'normal' } }}
							/>
						</div>
					)
				}
			</>
		);
	};


	  const getCategoryName = (category) => {
		switch (category) {
			case 'SOCIAL': return t("Social.label");
			case 'ENVIRONMENT': return t("Environment.label");
			case 'GOVERNANCE': return t("Governance.label");
		  default: 
			break;
		}
	  };

	const renderFiltersForKPIDataView = () => {
		return (
			<>
				<div className="col-lg-4 p-2">
					<label className="mb-1">{t("Category.label")}</label>
					<select className="form-select"
						value={filter.kpiCategory}
						onChange={(e) => setFilter({ ...filter, kpiCategory: e.target.value })}>
						<option value='' key=''>{t("All.label")}</option>
						{
							kpiCategories?.map((cat) => (
								<option value={cat.category} key={cat.id}>
									{getCategoryName(cat.category.toUpperCase())?.toUpperCase()}
								</option>
							))
						}
					</select>
				</div>
				<div className="col-lg-4 p-2">
					<label className="mb-1">{t("Goal.label")}</label>
					<select className="form-select"
						value={filter.goalId}
						onChange={(e) => setFilter({ ...filter, goalId: +e.target.value })}>
						<option value='' key=''>{t("All.label")}</option>
						{
							goals?.map((goal) => (
								<option value={goal.id} key={goal.id}>{goal.name}</option>
							))
						}
					</select>
				</div>
				<div className="col-lg-4 p-2">
					<label className="mb-1">{t("KPI.label")}</label>
					<select className="form-select"
						value={filter.kpiId}
						onChange={(e) => setFilter({ ...filter, kpiId: +e.target.value })}>
						<option value='' key=''>{t("All.label")}</option>
						{
							kpis?.map((k) => (
								<option value={k.id} key={k.id}>{k.name}</option>
							))
						}
					</select>
				</div>
				{
					view !== 'ACTIONS_VIEW' &&
					<div className="col-lg-4 p-2">
						<label >{t("Year")}</label>
						<ReportingPeriod
							defaultFrequency='ANNUAL'
							defaultPeriod={filter.reportingPeriod}
							valueChangeCallback={(period) => {
								setFilter({ ...filter, reportingPeriod: `${period.year}-01-01` })
							}} />
					</div>
				}
				{
					!forGraph &&
					<div className="col-lg-4 p-2">
						{
							view === 'ACTIONS_VIEW'
								?
								<>
									<label className="mb-1">{t("Assignee.label")}</label>
									<select className="form-select"
										value={filter.assigneeId}
										onChange={(e) => setFilter({ ...filter, assigneeId: +e.target.value })}>
										<option value='' key=''>{t("All.label")}</option>
										{
											users?.map((u) => (
												<option value={u.id} key={u.id}>{u.name}</option>
											))
										}
									</select>
								</>
								:
								<>
									<label className="mb-1">{t("Entity.label")}</label>
									<select className="form-select"
										value={filter.entityId}
										onChange={(e) => setFilter({ ...filter, entityId: +e.target.value })}>
										<option value='' key=''>{t("All.label")}</option>
										{
											entities?.map((e) => (
												<option value={e.id} key={e.id}>{e.name}</option>
											))
										}
									</select>
								</>
						}
					</div>
				}
			</>
		)
	};

	const fetchKPICategories = () => {
		KPIService.listKPICategory(companyId).then(res => {
			if (res.status !== 200) return;
			setKPICategories(res.data.data ?? []);
		}).catch(err => { });
	};

	const fetchGoals = (cat = '', firstTime = false) => {
		KPIService.listGoals(companyId, cat).then(res => {
			if (res.status !== 200) return;
			setGoals(res.data.data ?? []);
			if (forGraph && firstTime && res.data.data?.length > 0) {
				const f = { ...filter, goalId: goalId ?? res.data.data[0].id };
				setFilter(f);
				onLoad({ type: 'GOALS', filter: f });
			}
		}).catch(err => { });
	};

	const fetchEntities = () => {
		CompanyService.getEnterpriseStructure()
			.then(res => {
				if (res.status !== 200) return;

				const nodes = [];
				populateEntities(res.data.data ?? [], nodes);
				setEntities(nodes);
			})
			.catch(err => {
			});
	};

	const populateEntities = (children, nodes) => {
		children?.forEach(child => {
			nodes.push(child);
			if (child?.children?.length > 0) {
				populateEntities(child.children, nodes);
			}
		});
	};

	const fetchKPIs = (goalId) => {
		KPIService.getKPIs(goalId).then(res => {
			if (res.status !== 200) return;
			setKPIs(res.data.data ?? []);
		}).catch(err => {
		});
	};

	const fetchUsers = () => {
		UserService.getUsers(0, 10, '', '', true).then((res) => {
			if (res.status !== 200) return;

			setUsers(res.data);
		})
			.catch((error) => {
			});
	};


	return (
		<div>
			{
				displayFilter &&
				<div className="Main_filter 0">
					<div className="Main_filter_head">
						<h5>{t("Filter.label")}</h5>
						<button 
							type="button"
							className="btnClose" 
							onClick={() => onFilterHide(false)}
							aria-label={t("Filter.close.label") || "Close filter"}
						>
							<BiX />
						</button>
					</div>
					<div className="Main_filter_body">
						<div className="row m-0">
							{renderReportingPeriodFilter()}
							{
								(dataViewType === 'ESG_REPORTING' || viewType === 'COMPARE') &&
								renderMetricRelatedFilters()
							}
							{dataViewType === 'KPI' && renderFiltersForKPIDataView()}

						</div>
					</div>
					<div className="Main_filter_footer p-2 pb-3 text-center">
						<Button variant="primary"
							onClick={() => applyFilter()}
							className="sbmBtn px-4">
							{t("Apply.label")}
						</Button>
						<Button variant="secondary"
							onClick={() => resetFilter()}
							className="px-4 mx-2">
							{t("Reset.label")}
						</Button>
					</div>
				</div>
			}
		</div>
	);
};

export default withTranslation()(DataViewFilter);
